/* global locales */
import angular from 'angular';
import 'angular-bootstrap';
import locales from '../../locale';
import './newsServices';

const newsControllers = angular.module('applicationModule.newsControllers', ['applicationModule.newsServices', 'ui.bootstrap']);

// News Controllers
newsControllers.controller('NewsListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'News', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', '$filter', function ($scope, $rootScope, $stateParams, NgTableParams, News, growl, AppsoupAPI, Permissions, $state, $modal, $filter) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('news');
    $scope.application_id = $stateParams.application_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchItem = null;
    let isMainBu = false;
    $scope.currentBu = '';
    let user = {};
    let mainBu;
    let secondaryBu;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams('title'), {
        getData: function (params) {
            $scope.isLoading = true;
            return News.getList($scope.application_id, params && params._params ? params._params : {}).then(function (response) {
                if (response.success) {
                    $scope.tags = response.tags;
                    params.total(response.news.total);
                    params.count(response.news.per_page);
                    params.page(response.news.current_page);
                    if (angular.isDefinedNotNull($stateParams.searchNews)) {
                        $scope.search = $stateParams.searchNews;
                        $scope.searchNews($scope.search);
                    }
                    isMainBu = !!(response.client && response.client.bu === response.user.bu);
                    mainBu = response.client.bu;
                    secondaryBu = response.client.bu_types ? response.client.bu_types : [];
                    $scope.currentBu = response.user.bu ? response.user.bu : '';
                    user = response.user;
                    return response.news.data;
                } else {
                    $rootScope.$broadcast('404');
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.copyNews = function (id) {
        News.copy(id).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                growl.success('MODULES.NEWS.SUCCESS.COPY_NEWS');
                $state.go($state.current, {searchNews: $stateParams.searchNews}, {reload: true});
            } else {
                growl.error('MODULES.NEWS.ERROR.COPY_NEWS');
            }
        });
    };

    $scope.removeNews = function (id, index) {
        News.remove(id).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                growl.success('MODULES.NEWS.SUCCESS.DELETE_NEWS');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.NEWS.ERROR.DELETE');
            }
        });
    };

    $scope.searchNews = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);

        find.news_date = $filter('date')(find.news_date, 'yyyy-MM-dd');
        find.end_date = $filter('date')(find.end_date, 'yyyy-MM-dd');

        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.tags)) {
            $scope.tableParams._params.tags = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.news_date)) {
            $scope.tableParams._params.news_date = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.end_date)) {
            $scope.tableParams._params.end_date = undefined;
        }
        $stateParams.searchNews = null;
        $scope.searchItem = null;
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

    $scope.importTag = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/news/import-tags.tpl.html',
            controller: 'NewsModalController',
            backdrop: 'static',
            resolve: {}
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.NEWS.SUCCESS.IMPORT');
        }).catch(() => {});
    };

    $scope.isChangeEnabled = function (newsTags, newsAuthorBu) {
        let includedBu = 0;
        let hasOnlyOneBuTag = false;
        if (typeof newsTags === 'object') {
            const newsTagsChanged = Object.keys(newsTags).map(function (key) {
                return newsTags[key];
            });
            newsTags = newsTagsChanged;
        }
        if (newsTags) {
            angular.forEach(secondaryBu, function (val) {
                if (newsTags.includes(val)) {
                    includedBu++;
                }
            });
            hasOnlyOneBuTag = !!(!newsTags.includes(mainBu) && (includedBu === 1) && newsTags.includes($scope.currentBu));
        }
        const isAuthorBu = !!(newsAuthorBu && newsAuthorBu === $scope.currentBu);

        return !!(isMainBu || hasOnlyOneBuTag || user.superadmin || isAuthorBu);
    };

}]);

newsControllers.controller('NewsModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'News', '$filter', '$locale', function ($scope, $state, $stateParams, $modalInstance, growl, News, $filter, $locale) {
    'use strict';
    var appId = $stateParams.application_id;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    $scope.requiredFields = ['"link"'];
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;
    $scope.inputErrors = {};
    $scope.tag = {};
    $scope.imported = false;

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.import = function () {
        $scope.importForm.name.$invalid = false;
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.importForm.$valid) {

            $scope.isLoading = true;
            News.importTagCsv(appId, $scope.upload, $scope.tag).then(function (response) {
                const data = response.data || response;
                $scope.updated = [];
                $scope.notFound = [];
                if (data.success) {
                    $scope.imported = true;
                    $scope.newsUpdated = data.newsUpdated;
                    $scope.newsNotFound = data.newsNotFound;
                    growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                    $scope.upload = undefined;
                    $scope.fileUploaded = false;
                } else {
                    growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };
    $scope.ok = function () {
        $state.go($state.current, {}, {reload: true});
    };
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
    $scope.inputErrors = {
        'name': [{
            error: 'required',
            msg: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.REQUIRE.NAME'
        }, {error: 'pattern', msg: 'MODULES.NEWS.ERROR.INVALID_FORMAT'}]
    };
}]);

newsControllers.controller('NewsPageController', ['$scope', '$rootScope', '$locale', '$filter', '$state', '$stateParams', '$translate', 'growl', 'News', '$modal', function ($scope, $rootScope, $locale, $filter, $state, $stateParams, $translate, growl, News, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id, module: 'news'});
    $scope.news = {
        full_content: '',
        attributes: {}
    };
    $scope.news.status = true;
    $scope.editMode = false;
    $scope.news.app_id = $stateParams.application_id;
    var appId = $stateParams.application_id;
    $scope.news.full_content = '';
    $scope.news.language = 'pl';
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    var newsId = $stateParams.newsId;
    $scope.uploadLogo = undefined;
    $scope.fileUploadedLogo = false;
    $scope.fileUploaded = {};
    $scope.fileContractorUploaded = false;
    $scope.applicationPackageId = false;
    $scope.uploadContractor = false;
    $scope.imageRequired = true;
    $scope.imageSize = true;
    $scope.upload = undefined;
    $scope.uploadInfographics = undefined;
    $scope.imageType = [
        'image',
        'infographics',
        'thumbnail',
        'big_image',
        'image_background'
    ];

    $scope.news_attributes = {};

    $scope.tinymceOptions = angular.getTinymceOptions($modal);

    function loadDefaultAttributes() {
        News.getAttributes(appId).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                $scope.news_attributes = data.attributes;
                angular.forEach($scope.news_attributes, function (attribute, key) {
                    if (!$scope.news.attributes[key] && $scope.news_attributes[key].default) {
                        $scope.news.attributes[key] = $scope.news_attributes[key].default;
                    }
                });
            }
        });
    }

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    News.getAttributes(appId).then(function (response) {
        const data = response.data;
        if (data.success) {
            $scope.news_attributes = data.attributes;
            $scope.package_id = data.package_id;
        }
    });

    News.getLanguages().then(function (response) {
        const data = response.data;
        if (data.success) {
            $scope.languages = data.languages;
        }
    });
    $scope.uploadSuccess = function (file) {
        $scope.uploadContractor = file;
        $scope.errorRequired = false;
        $scope.fileContractorUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };
    $scope.$watch('uploadContractor', function () {
        if ($scope.uploadContractor) {
            if ($scope.uploadContractor[0] && $scope.uploadContractor[0][0] && $scope.uploadContractor[0][0].indexOf('.csv') === -1) {
                growl.error('ERROR.CONTRACTOR.INVALID_FORMAT');
            }
        }
    });
    $scope.removeFile = function () {
        $scope.news.uploadContractor = null;
        $scope.uploadContractor = undefined;
        $scope.fileContractorUploaded = false;
        $scope.file_name = null;
        $scope.invalidContractor = null;
    };

    $scope.generateUrl = function (name) {
        if (name) {
            var dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
            var str = angular.copy(name);
            str = str.replace(/\s+/g, '-').toLowerCase();
            str = str.replace(/[^\w ]/g, function (char) {
                return dict[char] || char;
            });
            str = str.replace(/[^0-9a-z-]+/g, '');
            str = str.replace(/[-]+/g, '-');
            str = str + '/';
            $scope.news.url = str;
        }
    };

    $scope.showElement = function (value) {
        return (angular.isDefined(value) && value);
    };
    $scope.autocomplete = function (text) {
        text = $filter('removeSpecial')(text);

        News.tags($scope.news.app_id, text).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.tags = data.tags;
            }
        });
    };

    $scope.tags = [];

    $scope.changeTags = function () {
        if (angular.isDefined($scope.news.tags)) {
            var tempTags = [];
            angular.forEach($scope.news.tags, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.news.tags = tempTags;
        }
    };

    $scope.user = {};
    let isMainBu;
    let currentBu = '';
    let mainBu;
    let secondaryBu = [];
    let initialTags = [];

    News.getCurrentUser()
        .then(function (response) {
            const data = response.data;
            if (data.user) {
                currentBu = data.user.bu ? data.user.bu : '';
                $scope.user = data.user;
            }
            if (data.client) {
                mainBu = data.client.bu ? data.client.bu : '';
                secondaryBu = data.client.bu_types ? data.client.bu_types : [];
            }
        });

    if (angular.isDefined(newsId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;
        News.get(newsId, appId).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                data.news.tags = data.news.tags ? data.news.tags : [];
                $scope.news = data.news;
                $scope.news_url = angular.copy(data.news.url);
                $scope.client_url = data.client_url;
                $scope.user = data.user;
                $scope.file_name = data.file_name;
                if ($scope.file_name) {
                    $scope.fileContractorUploaded = true;
                }
                $scope.package_id = data.package_id;
                angular.forEach($scope.imageType, function (value) {
                    if ($scope.news[value]) {
                        $scope.fileUploaded[value] = true;
                    }
                });
                isMainBu = !!(data.client && data.client.bu === data.user.bu);
                currentBu = data.user.bu ? data.user.bu : '';
                secondaryBu = (data.client && data.client.bu_types) ? data.client.bu_types : [];
                mainBu = data.client.bu ? data.client.bu : '';
                initialTags = angular.copy(data.news.tags);
                const isAuthorBu = !!($scope.news.author_bu && $scope.news.author_bu === currentBu);

                let includedBu = 0;
                angular.forEach(secondaryBu, function (val) {
                    if ($scope.news.tags.indexOf(val) > -1) {
                        includedBu++;
                    }
                });

                if (!(isMainBu || (!$scope.news.tags.includes(mainBu) && (includedBu === 1) && $scope.news.tags.includes(currentBu)) || data.user.superadmin || isAuthorBu)) {
                    $state.go('appsoup.application.news', {application_id: appId}, growl.error('MODULES.NEWS.ERROR.EDIT_NO_ACCESS'));
                }
            } else {
                $state.go('appsoup.application.news', {application_id: appId}, growl.error('MODULES.NEWS.ERROR.NO_DATA'));
            }
        }).finally(function () {
            $rootScope.doingResolve = false;
            loadDefaultAttributes();
        });
    } else {
        var today = new Date();
        $scope.news.news_date = $filter('date')(today.getTime(), 'dd-MM-yyyy');
        loadDefaultAttributes();
    }

    const forbiddenBuUsed = [];
    const removeTag = function (tag, list) {
        let found = list.indexOf(tag);
        while (found !== -1) {
            list.splice(found, 1);
            found = list.indexOf(tag);
        }
        forbiddenBuUsed.push(tag);
    };

    const addTag = function (tag, list) {
        list.push(tag);
        forbiddenBuUsed.push(tag);
    };

    $scope.saveNews = function () {
        $scope.newsForm.url.$invalid = false;
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.newsForm.$valid) {
            $scope.isLoading = true;

            if (angular.isDefined(newsId)) {
                $scope.news.id = newsId;
            }

            if (angular.isDefined($scope.news.tags)) {
                var tags = [];

                angular.forEach($scope.news.tags, function (value) {
                    value = $filter('removeSpecial')(value);
                    if (angular.isDefined(value)) {
                        tags.push(value);
                    }
                });

                $scope.news.tags = tags;
            }

            if (angular.isArray($scope.news.attributes)) {
                $scope.news.attributes = angular.extend({}, $scope.news.attributes);
            }

            if (!$scope.editMode && currentBu) {
                if (angular.isDefined($scope.news.tags) && !$scope.news.tags.includes(currentBu)) {
                    $scope.news.tags.push(currentBu);
                } else if (angular.isUndefined($scope.news.tags)) {
                    const tags = [];
                    tags.push(currentBu);
                    $scope.news.tags = tags;
                }
                $scope.news.author_bu = currentBu;
            }

            if (!(isMainBu || $scope.user.superadmin)) {
                const tmpTags = $scope.news.tags ? angular.copy($scope.news.tags) : [];

                angular.forEach(secondaryBu, function (bu) {
                    if (bu !== currentBu) {
                        if (!initialTags.includes(bu) && tmpTags.includes(bu)) {
                            // remove forbidden bu tags added while editing
                            removeTag(bu, tmpTags);
                        } else if (initialTags.includes(bu) && !tmpTags.includes(bu)) {
                            // add forbidden bu tags removed while editing
                            addTag(bu, tmpTags);
                        }
                    }
                });
                if (mainBu !== currentBu) {

                    if (!initialTags.includes(mainBu) && tmpTags.includes(mainBu)) {
                        // remove forbidden main bu tag added while editing
                        removeTag(mainBu, tmpTags);
                    } else if (initialTags.includes(mainBu) && !tmpTags.includes(mainBu)) {
                        // add forbidden main bu tag removed while editing
                        addTag(mainBu, tmpTags);
                    }
                }

                $scope.news.tags = tmpTags;
            }

            News.save($scope.news, $scope.editMode, $scope.uploadContractor, $scope.file_name).then(function (response) {
                const data = response.data || response;
                if (data.success) {
                    if (forbiddenBuUsed.length) {
                        let text = '';
                        text = text + $translate.instant('MODULES.NEWS.SUCCESS.' + ($scope.editMode ? 'EDIT_NEWS' : 'NEW_NEWS')) + '   ';
                        text = text + $translate.instant('MODULES.NEWS.ERROR.USE_FORBIDDEN_BU') + '   ';
                        angular.forEach(forbiddenBuUsed, function (value, key) {
                            text = text + value;
                            if (forbiddenBuUsed.length - 1 === key) {
                                text = text + ';';
                            } else {
                                text = text + ', ';
                            }
                        });
                        growl.success(text, {translateMessage: false});
                    } else {
                        growl.success('MODULES.NEWS.SUCCESS.' + ($scope.editMode ? 'EDIT_NEWS' : 'NEW_NEWS'));
                    }
                    if ($scope.editMode) {
                        $state.go($state.current, {searchNews: $stateParams.searchNews}, {reload: true});
                    } else {
                        $state.go('appsoup.application.editNews', {newsId: data.news.id}, {reload: true});

                    }
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                        if (data.error.contractors) {
                            $scope.invalidContractor = data.error.contractors;
                        }
                    } else {
                        growl.error('MODULES.FILES.ERROR.SHARED');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.changeDate = function () {
        if (angular.isDefinedNotNull($scope.news.end_date) && ($scope.news.news_date > $scope.news.end_date)) {
            $scope.news.end_date = $scope.news.news_date;
        }
    };

    $scope.downloadFile = function () {
        News.downloadFile($scope.news.app_id, newsId)
            .then(function (response) {
                const data = response.data || response;
                angular.openInNewTab(data.fileUrl);
            });
    };

    $scope.inputErrors = {
        'title': [{error: 'required', msg: 'MODULES.NEWS.FORM_ERROR.TITLE'}],
        'url': [{type: '$invalid', msg: 'MODULES.NEWS.FORM_ERROR.URL'}],
        'content': [
            {error: 'required', msg: 'MODULES.NEWS.FORM_ERROR.CONTENT'},
            {
                error: 'maxlength',
                msg: 'MODULES.NEWS.FORM_ERROR.CONTENT_MAX_LENGTH'
            }
        ],
        'full_content': [{error: 'required', msg: 'MODULES.NEWS.FORM_ERROR.FULL_CONTENT'}],
        'news_date': [
            {error: 'required', msg: 'MODULES.NEWS.FORM_ERROR.NEWS_DATE'},
            {
                error: '$invalid',
                msg: 'FORM.ERRORS.FORMAT'
            }
        ],
        'end_date': [{error: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'image_link': [
            {error: 'required', msg: 'MODULES.NEWS.FORM_ERROR.IMAGE_LINK'},
            {
                error: 'pattern',
                msg: 'MODULES.NEWS.FORM_ERROR.LINK_FORMAT'
            }
        ],
        'news_link': [
            {error: 'required', msg: 'MODULES.NEWS.FORM_ERROR.NEWS_LINK'},
            {
                error: 'pattern',
                msg: 'MODULES.NEWS.FORM_ERROR.LINK_FORMAT'
            }
        ]
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.news', {searchNews: $stateParams.searchNews});
    };

    $scope.$watch('upload', function () {
        if (angular.isDefined($scope.upload)) {
            $scope.news.image = $scope.upload;
        }
    });

    $scope.$watch('uploadInfographics', function () {
        if (angular.isDefined($scope.uploadInfographics)) {
            $scope.news.infographics = $scope.uploadInfographics;
        }
    });
}])
    .config([
        'datepickerConfig',
        'datepickerPopupConfig',
        function (datepickerConfig, datepickerPopupConfig) {
            angular.extend(datepickerConfig, {});

            angular.extend(datepickerPopupConfig, {});
        }
    ]);

// News Update Tags Controller
newsControllers.controller('NewsUpdateTagsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'News', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', '$translate', function ($scope, $rootScope, $stateParams, NgTableParams, News, growl, AppsoupAPI, Permissions, $state, $modal, $translate) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('news');
    $scope.app_id = $stateParams.application_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchItem = null;
    $scope.checkedNews = [];
    if ($stateParams.tag) {
        var string = $stateParams.tag.trim().toLowerCase();
        var result = string.match(/[^\w\s\d]+/);
        if (result) {
            $state.go('appsoup.application.news', {application_id: $scope.app_id}, growl.error('MODULES.NEWS.ERROR.INVALID_TAG_NAME'));
        }
        $scope.tag = $stateParams.tag;
    } else {
        $state.go('appsoup.application.news', {application_id: $scope.app_id}, growl.error('MODULES.NEWS.ERROR.NO_TAG'));
    }

    $scope.tableParams = new NgTableParams(AppsoupAPI.getCreatedAtTableParams('created_at'), {
        getData: function (params) {
            $scope.isLoading = true;
            return News.getList($scope.app_id, params._params).then(function (response) {
                if (response.success) {
                    $scope.tags = response.tags;
                    params.total(response.news.total);
                    params.count(response.news.per_page);
                    params.page(response.news.current_page);

                    if (angular.isDefinedNotNull($stateParams.searchNews)) {
                        $scope.search = $stateParams.searchNews;
                        $scope.searchNews($scope.search);
                    }

                    return response.news.data;
                } else {
                    $rootScope.$broadcast('404');
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });
    $scope.searchNews = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };
    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.tags)) {
            $scope.tableParams._params.tags = undefined;
        }
        $stateParams.searchNews = null;
        $scope.searchItem = null;
    };
    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

    $scope.massiveAddTag = function () {
        $scope.isLoadingMassive = true;
        News.addTag($scope.tag, $scope.checkedNews, $scope.app_id).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                growl.success('MODULES.NEWS.SUCCESS.TAG_ADDED');
            } else {
                growl.error('MODULES.NEWS.ERROR.TAG_ADDED');
            }
        }).finally(function () {
            $state.go($state.current, {}, {reload: true});
            $scope.isLoadingMassive = false;
        });
    };

    $scope.massiveRemoveTag = function () {
        $scope.isLoadingMassive = true;
        News.removeTag($scope.tag, $scope.checkedNews, $scope.app_id).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                if (data.tagNotExists) {
                    var text = '';
                    text = text + $translate.instant('MODULES.NEWS.ERROR.TAG_NOT_EXISTS') + '\n';
                    angular.forEach(data.tagNotExists, function (value, key) {
                        text = text + value;
                        if (data.tagNotExists.length - 1 === key) {
                            text = text + ';';
                        } else {
                            text = text + ',\n';
                        }
                    });
                    growl.error(text, {translateMessage: false});
                } else {
                    growl.success('MODULES.NEWS.SUCCESS.TAG_REMOVED');
                }
                $state.go($state.current, {}, {reload: true});
            } else {
                growl.error('MODULES.NEWS.ERROR.TAG_REMOVED');
            }
        }).finally(function () {
            $scope.isLoadingMassive = false;
        });
    };

    $scope.addTag = function (newsId) {
        News.addTag($scope.tag, newsId, $scope.app_id).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                growl.success('MODULES.NEWS.SUCCESS.TAG_ADDED');
                $state.go($state.current, {}, {reload: true});
            } else {
                growl.error('MODULES.NEWS.ERROR.TAG_ADDED');
            }
        });
    };

    $scope.removeTag = function (newsId) {
        News.removeTag($scope.tag, newsId, $scope.app_id).then(function (response) {
            const data = response.data || response;
            if (data.success) {
                if (data.tagNotExists) {
                    growl.error('MODULES.NEWS.ERROR.TAG_REMOVED');
                } else {
                    growl.success('MODULES.NEWS.SUCCESS.TAG_REMOVED');
                }
                $state.go($state.current, {}, {reload: true});
            } else {
                growl.error('MODULES.NEWS.ERROR.TAG_ADDED');
            }
        });
    };

    $scope.selectNews = function (id) {
        $scope.checkedNews = angular.selectElement($scope.checkedNews, id);

        if ($scope.checkedNews.length < 1) {
            $scope.clearAction();
        }
    };

    $scope.selectAllNews = function (item) {
        $scope.checkedNews = angular.selectAllElements($scope.checkedNews, item);
    };

    $scope.checkSelectedNews = function (item) {
        return angular.checkSelectedElements($scope.checkedNews, item);
    };

}]);

export default newsControllers;
